import {
  Route,
  createBrowserRouter,
  createRoutesFromElements,
  RouterProvider,
} from "react-router-dom";
import { lazy } from 'react';
import Protected from "./protected";
import { isAuthenticated } from "./helpers";
import Home from "../Pages/Home";
import Login from "../Pages/Login";
import EmployeeDetails from "../Pages/EmployeeDetails";
import Finance from '../Pages/finance/Finance'
import TransactionDetails from '../Pages/finance/components/transactionDetails'
// const EmployeeDetails = lazy(() => import("../Pages/EmployeeDetails"));
// const Login = lazy(() => import("../Pages/Login"));

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/">
      <Route element={<Protected />}>
        {/* All other routes that you want to protect will go inside here */}
      </Route>
      <Route index element={<Home />} />
      <Route
        path="businessDashboard/myTeam"
        element={<Login />}
        // loader={async () => await isAuthenticated()}
      />
      <Route path="businessDashboard/EmployeeDetails/:userId" element={<EmployeeDetails />} />
      <Route path="businessDashboard/Finance" element={<Finance />} />
      <Route path="businessDashboard/TransactionDetails" element={<TransactionDetails />} />
      
      
      <Route path="*" element={<h1>Page not found</h1>} />
    </Route>
  )
);

const Index = () => {
  return <RouterProvider router={router} />;
};

export default Index;
